/**
 * theCrag exports ascent dates as ISO UTC midnight (e.g. "2026-04-20T00:00:00Z").
 * Treat them as calendar dates — never let the local timezone shift the day.
 */

export function getAscentDateParts(dateStr) {
  if (!dateStr) return null;
  const [y, m, d] = dateStr.slice(0, 10).split('-').map(Number);
  if (!y || !m || !d) return null;
  return { year: y, month: m, day: d };
}

export function formatAscentDate(dateStr, locale = undefined) {
  const parts = getAscentDateParts(dateStr);
  if (!parts) return '';
  return new Date(parts.year, parts.month - 1, parts.day).toLocaleDateString(locale);
}

export function formatAscentDateLong(dateStr) {
  const parts = getAscentDateParts(dateStr);
  if (!parts) return '';
  return new Date(parts.year, parts.month - 1, parts.day).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
}
